// src/components/tasks/taskConstants.js
import React from 'react';
import {
  RadioButtonUnchecked as TodoIcon,
  Check as CheckIcon,
  TimerOutlined as InProgressIcon,
  RateReviewOutlined as InReviewIcon,
  Flag as FlagIcon
} from '@mui/icons-material';

// Status options for quick selection
export const STATUS_OPTIONS = [
  { value: 'to_do', label: 'To Do', icon: <TodoIcon fontSize="small" /> },
  { value: 'in_progress', label: 'In Progress', icon: <InProgressIcon fontSize="small"  /> },
  { value: 'in_review', label: 'In Review', icon: <InReviewIcon fontSize="small" color="secondary" /> },
  { value: 'done', label: 'Done', icon: <CheckIcon fontSize="small" color="success" /> }
];

// Priority options
export const PRIORITY_OPTIONS = [
  { value: 'low', label: 'Low', color: 'success.main' },
  { value: 'medium', label: 'Medium', color: 'info.main' },
  { value: 'high', label: 'High', color: 'warning.main' },
  { value: 'urgent', label: 'Urgent', color: 'error.main' }
];

// Content stage options
export const CONTENT_STAGES = [
  { value: 'todo', label: 'To Do' },
  { value: 'idea', label: 'Idea' },
  { value: 'reference', label: 'Reference' },
  { value: 'creative', label: 'Creative' },
  { value: 'posting', label: 'Posting' },
  { value: 'completed', label: 'Completed' }
];

// Task types
export const TASK_TYPES = [
  { value: 'general', label: 'General' },
  { value: 'design', label: 'Design' },
  { value: 'development', label: 'Development' },
  { value: 'content', label: 'Content' },
  { value: 'review', label: 'Review' },
  { value: 'administrative', label: 'Administrative' },
  { value: 'other', label: 'Other' }
];
// Pagination constants
export const TASKS_PER_SECTION = 5;